import { useMemo } from "react";
import Table, { TableColumns } from "../../components/table";
import { RepaymentCommitment } from "../../dto";
import { dateToDDMMYYYY } from "../../utils";

const REPAYMENT_COMMITMENTS_TABLE_COLUMNS: TableColumns[] = [
  { label: "ID", field: "_id", style: { textAlign: "center" } },
  { label: "Commit On", field: "committedAt", style: { textAlign: "center" } },
  { label: "Amount", field: "amount", style: { textAlign: "center" } },
  {
    label: "Reference ID",
    field: "clientReferenceId",
    style: { textAlign: "center" },
  },
  { label: "Reported At", field: "reportedAt" },
];

const getTableDataForLoanRepaymentCommitments = (
  data: RepaymentCommitment[],
) => {
  if (!data) return [];
  return data.map(({ committedAt, reportedAt, amount, ...rest }) => ({
    ...rest,
    amount: amount.toFixed(2),
    committedAt: dateToDDMMYYYY(committedAt),
    reportedAt: dateToDDMMYYYY(reportedAt),
  }));
};

interface LoanRepaymentCommitmentProps {
  repaymentCommitments: RepaymentCommitment[] | null;
}

export default function LoanRepaymentCommitment({
  repaymentCommitments,
}: LoanRepaymentCommitmentProps) {
  const tableDataForLoanRepaymentCommitments = useMemo(() => {
    if (!repaymentCommitments) return [];
    return getTableDataForLoanRepaymentCommitments(repaymentCommitments);
  }, [repaymentCommitments]);

  return null;

  return (
    <div>
      <h3 className="user-page-title  mb-4">
        Payment Commitments (From Employer Partners)
      </h3>
      <Table
        data={tableDataForLoanRepaymentCommitments}
        columns={REPAYMENT_COMMITMENTS_TABLE_COLUMNS}
      />
    </div>
  );
}
